module.exports = __webpack_public_path__ + "img/slavery-in-the-age-of-abolition.5fded9a0.png";